import type { Template } from "@/types";

export const LA_05_H4_V1: Template[] = [
{
    id: "la-05-h4v1-01",
    name: "LA 01 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 63, y: 72, width: 511, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 72, width: 161, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 186, width: 161, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 299, width: 161, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 919, y: 72, width: 243, height: 333, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-02",
    name: "LA 02 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 61, y: 59, width: 253, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 247, width: 253, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 59, width: 253, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 247, width: 253, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 821, y: 59, width: 270, height: 367, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-03",
    name: "LA 03 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 116, y: 74, width: 243, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 116, y: 242, width: 243, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 450, y: 0, width: 373, height: 476, rotation: 0, imageRotation: 0 },
            { id: "4", x: 915, y: 74, width: 243, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 915, y: 242, width: 243, height: 160, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-04",
    name: "LA 04 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 159, width: 222, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 230, y: 159, width: 222, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 460, y: 0, width: 354, height: 476, rotation: 0, imageRotation: 0 },
            { id: "4", x: 822, y: 159, width: 222, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1052, y: 159, width: 222, height: 160, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-05",
    name: "LA 05 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 223, y: 39, width: 192, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 223, y: 309, width: 192, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 823, y: 39, width: 266, height: 396, rotation: 0, imageRotation: 0 },
            { id: "4", x: 123, y: 174, width: 193, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 324, y: 174, width: 192, height: 126, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-06",
    name: "LA 06 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 103, y: 47, width: 431, height: 288, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 342, width: 139, height: 91, rotation: 0, imageRotation: 0 },
            { id: "3", x: 249, y: 342, width: 139, height: 91, rotation: 0, imageRotation: 0 },
            { id: "4", x: 395, y: 342, width: 139, height: 91, rotation: 0, imageRotation: 0 },
            { id: "5", x: 812, y: 47, width: 286, height: 385, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-07",
    name: "LA 07 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 189, y: 33, width: 284, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 243, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 481, y: 33, width: 313, height: 410, rotation: 0, imageRotation: 0 },
            { id: "4", x: 801, y: 33, width: 284, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 801, y: 243, width: 284, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-08",
    name: "LA 08 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 49, width: 547, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 598, y: 49, width: 378, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 598, y: 299, width: 186, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 792, y: 299, width: 185, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 984, y: 49, width: 249, height: 377, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-09",
    name: "LA 09 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 49, width: 377, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 299, width: 185, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 236, y: 299, width: 185, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 428, y: 49, width: 547, height: 377, rotation: 0, imageRotation: 0 },
            { id: "5", x: 982, y: 49, width: 249, height: 377, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h4v1-10",
    name: "LA 10 - H4V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 49, width: 249, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 300, y: 49, width: 547, height: 377, rotation: 0, imageRotation: 0 },
            { id: "3", x: 854, y: 186, width: 377, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 49, width: 185, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1046, y: 49, width: 185, height: 129, rotation: 0, imageRotation: 0 }
    ],
}
];